export const CONTAINER_MAX_WIDTH = '87.5rem'
